import { TRACKING } from 'common/constants/constants';
import * as TrackingService from 'common/services/tracking.service';
import { navigateBookDemoClick } from 'common/utils/utils';
import UpgradeEmptyState from 'components/base/UpgradeEmptyState';
import {
  GrayBackground,
  Page,
  WhiteSection
} from 'components/base/layout-components';
import characterConnectProjectsImg from 'images/characters/character-connect-projects.svg';
import upgradeEmptyStateImg from 'images/projects-empty-state.png';
import ProjectsEmptyState from 'images/projects-empty-state.svg';
import { createEditProjectsModalOptions } from 'modals/modal-options-factory';
import styled from 'styled-components';
import EmptyProjects from './EmptyProjects';
import { Redirect } from 'react-router';
import AppRouter from 'common/AppRouter';

const EmptyStateImage = styled.img`
  width: 100%;
`;

const StyledBackground = styled(GrayBackground)`
  height: 100%;
`;

const ProjectsEmptyStates = ({
  toggleModal,
  pmSensorAuthId,
  isCanConfigProjects,
  shouldShowUpgradeEmptyState,
  loading,
  projects = [],
  newProjects = [],
  onSaveClick,
  onlyFavorites
}) => {
  if (shouldShowUpgradeEmptyState) {
    return (
      <Page>
        <UpgradeEmptyState
          EmptyStateImg={upgradeEmptyStateImg}
          title='Upgrade to see the projects page'
          info={
            <>
              Find out how projects are<br></br> progressing, who’s doing the
              work,<br></br> what type of issues take up most<br></br> of your
              time and how well you are<br></br> planning ahead
            </>
          }
          RightSideLogo={() => (
            <img
              src={characterConnectProjectsImg}
              alt=''
              height='100'
              width='150'
            />
          )}
          buttons={[
            {
              text: 'Upgrade plan',
              onClick: () => {
                navigateBookDemoClick();
                TrackingService.logEvent(TRACKING.EVENTS.CLICK, {
                  page: TRACKING.PAGES.DASHBOARD,
                  page_tab: TRACKING.PAGE_TABS.EMPTY_STATE
                });
              }
            }
          ]}
        />
      </Page>
    );
  }

  if (loading) {
    return (
      <Page>
        <StyledBackground>
          <WhiteSection>
            <EmptyStateImage
              src={ProjectsEmptyState}
              alt='Projects empty state'
            />
          </WhiteSection>
        </StyledBackground>
      </Page>
    );
  }

  if (!loading && !projects.length && !newProjects.length) {
    if (onlyFavorites) {
      return (
        <Redirect
          to={{
            pathname: AppRouter.PROJECTS_API_ALL.path,
            search: window.location.search
          }}
        />
      );
    }
    return (
      <Page>
        <EmptyProjects
          onAddProjectClick={() =>
            toggleModal(
              createEditProjectsModalOptions({
                isEdit: false,
                pmSensorAuthId,
                onSaveClick
              })
            )
          }
          isCanConfigProjects={isCanConfigProjects}
        />
      </Page>
    );
  }
};

export default ProjectsEmptyStates;
